/* product.js — PDP variant picker, sticky tag chip, sticky mobile ATC. Hardened: whole body
 * wrapped so one failure can't break the page; variant JSON parse guarded. */
(function () {
  'use strict';
  try {
    const root = document.querySelector('[data-product-root]');
    if (!root) return;

    let variants = [];
    try { variants = JSON.parse(root.dataset.variants || '[]'); } catch (e) { console.error('product.js: variants parse failed', e); variants = []; }
    const sizeBtns = root.querySelectorAll('[data-size]');
    const swatches = root.querySelectorAll('[data-swatch]');
    const idInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price]');
    const codeEl = root.querySelector('[data-product-code]');
    const submitBtn = root.querySelector('[data-add-btn]');
    const moneyFormat = (window.Dandy && window.Dandy.money_format) || '${{amount}}';

    let selected = { Size: null, Color: null };

    function formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, value);
    }

    function findVariant() {
      return variants.find((v) => {
        const opts = v.options || [];
        const matchSize = !selected.Size || opts.includes(selected.Size);
        const matchColor = !selected.Color || opts.includes(selected.Color);
        return matchSize && matchColor;
      });
    }

    function update() {
      const v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl && priceEl !== submitBtn) priceEl.textContent = formatMoney(v.price);
      if (codeEl && v.sku) codeEl.textContent = `No. ${v.sku}`;
      if (submitBtn) {
        submitBtn.disabled = !v.available;
        const addLabel = (window.Dandy && window.Dandy.strings && window.Dandy.strings.add_to_bag) || 'Add to bag';
        const soldLabel = (window.Dandy && window.Dandy.strings && window.Dandy.strings.sold_out) || 'Sold out';
        const salePct = (window.Dandy && window.Dandy.sale_percent) || 0;
        if (!v.available) {
          submitBtn.textContent = soldLabel;
        } else if (salePct > 0) {
          // Sale display layer — charging is the automatic discount at checkout.
          const saleP = Math.round((v.price * (100 - salePct)) / 100);
          submitBtn.innerHTML = addLabel + ' — <s class="ts-was">' + formatMoney(v.price) + '</s> <b class="ts-now">' + formatMoney(saleP) + '</b>';
        } else {
          submitBtn.textContent = addLabel + ' — ' + formatMoney(v.price);
        }
      }
    }

    sizeBtns.forEach((b) => {
      b.addEventListener('click', () => {
        selected.Size = b.dataset.size;
        sizeBtns.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        sizeBtns.forEach((x) => x.classList.toggle('is-active', x === b));
        update();
      });
    });

    swatches.forEach((s) => {
      s.addEventListener('click', () => {
        selected.Color = s.dataset.swatch;
        swatches.forEach((x) => x.classList.toggle('is-active', x === s));
        update();
      });
    });

    const tagChip = document.querySelector('[data-sticky-tag]');
    const gallery = document.querySelector('[data-gallery]');
    if (tagChip && gallery) {
      const io = new IntersectionObserver(
        (entries) => { entries.forEach((e) => tagChip.classList.toggle('is-on', !e.isIntersecting)); },
        { threshold: 0 }
      );
      io.observe(gallery);
    }

    const atc = document.querySelector('[data-sticky-atc]');
    const panel = document.querySelector('[data-pdp-panel]');
    if (atc && panel) {
      const io = new IntersectionObserver(
        (entries) => { entries.forEach((e) => atc.classList.toggle('is-on', !e.isIntersecting)); },
        { threshold: 0 }
      );
      io.observe(panel);
    }

    const activeSize = root.querySelector('[data-size].is-active');
    if (activeSize) selected.Size = activeSize.dataset.size;
    const activeSwatch = root.querySelector('[data-swatch].is-active');
    if (activeSwatch) selected.Color = activeSwatch.dataset.swatch;

    update();
  } catch (e) { console.error('product.js failed', e); }
})();
